/**
 * Object.is polyfill (required for IE11)
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
export default (x: unknown, y: unknown): boolean =>
  (x === y && (x !== 0 || 1 / x === 1 / (y as number))) || (x !== x && y !== y); // eslint-disable-line no-self-compare
